module.exports = __webpack_public_path__ + "static/media/msl_white_4-3.51f051e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/msl_white_4-3.jpg
// module id = 77
// module chunks = 0